import { IDeliveryExternalFile } from './Entities';
import { Translate } from '../../../shared/LanguageService';

export default function openImage(image: IDeliveryExternalFile) {
    const { apiUrl } = window.appConfig;

    /* TODO: Setting window size this way is not an elegant solution, maybe it can be done better with css */
    let url = `${apiUrl}/file/${image.fileReference}`;
    let style = ' body { max-width:1500px; }';
    style += ' a{ }';
    style += ' a img {     max-width:100%; max-height:100vh; }';
    let newWindow = window.open(
        '',
        'pictureViewer',
        'location=no, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, resizable=yes, width=800, height=800'
    );
    newWindow.document.writeln('<html>');
    newWindow.document.writeln('<head>');
    newWindow.document.writeln(`<title>${image.filename}</title>`);
    newWindow.document.writeln(`<style>${style}</style>`);
    newWindow.document.writeln('</head>');
    newWindow.document.writeln("<body style='margin: 0 0 0 0;'>");
    newWindow.document.writeln(
        `<a title='${Translate(
            'plan/check-delivery/correction-file/window/hover'
        )}' href='javascript:window.close();'>`
    );
    newWindow.document.writeln(
        `<img src='${url}' alt='${Translate(
            'plan/check-delivery/correction-file/window/hover'
        )}' id='image'/>`
    );
    newWindow.document.writeln('</a>');
    newWindow.document.writeln('</body></html>');
    newWindow.document.close();
}
